import axios from 'axios';

//const API_BASE_URL = 'http://localhost:8080';
const API_BASE_URL = 'https://web.omkarahostel.com/OmkaraHostel';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add JWT token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('✅ Token added to request:', config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ── Session expired handler — prevent multiple popups if many requests fail ──
let sessionExpiredShown = false;
const handleSessionExpired = () => {
  if (sessionExpiredShown) return;
  sessionExpiredShown = true;

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('currentScreen');
  localStorage.removeItem('completeRegistrationData');
  localStorage.removeItem('registrationData');

  alert('⚠️ Your session has expired. Please login again.');
  window.location.reload();
};

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message = (error.response?.data?.message || '').toLowerCase();

    if (status === 401) {
      console.error('❌ 401 Unauthorized - Token expired or invalid');
      handleSessionExpired();
    }

    if (status === 403) {
      // 403 from Spring Security = token expired/invalid (not permission denied)
      const isTokenError =
        message.includes('expired') ||
        message.includes('invalid') ||
        message.includes('jwt') ||
        message.includes('token') ||
        message === ''; // blank = auth filter rejection
      if (isTokenError) {
        console.error('❌ 403 Forbidden - Token expired or invalid');
        handleSessionExpired();
      }
    }

    return Promise.reject(error);
  }
);

export default api;